import React, { PointerEventHandler, useRef, useState } from 'react';
// import ComingSoonWrap from '../../../meta/ComingSoon';
import { AnimatePresence, motion, useMotionValue } from 'motion/react';
import { animate } from 'motion';
import SymbolRing from '../../Effects/SymbolRing';
import ComingSoonWrap from '../../../meta/ComingSoon';
import useDebounce from '../../../../../utils/hooks/useDebounce';

const WinkBox: React.FC = () => {
    const [letterShown, setLettersShown] = useState(0);

    useDebounce(() => {
        if (letterShown < 2) {
            setLettersShown(letterShown + 1)
        }
    }, 750, [letterShown])

    return (
        <motion.p exit={{ opacity: 0, transition: { duration: 2, ease: 'easeIn' } }} className='text-teko text-7xl '>
            <span className={letterShown > 0 ? 'visible' : 'invisible'}>; </span>
            <span className={letterShown > 1 ? 'visible' : 'invisible'}>&#41;</span>
        </motion.p>
    )
}

const EdgeMerchNotice: React.FC = () => {
    const [wink, setWink] = useState(false);

    const ringOpacity = useMotionValue(0);
    const ringX = useMotionValue(0);
    const ringY = useMotionValue(0);

    const textOpacity = useMotionValue(1);

    const handleOnPointerEnter = () => animate(ringOpacity, 1);
    const handleOnPointerLeave = () => {
        animate(ringOpacity, 0);
        animate(textOpacity, 1);
    };

    const zoneRef = useRef<HTMLDivElement>(null);
    const symbolRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleOnPointerMove: PointerEventHandler = (e,) => {
        const zoneRect = zoneRef.current!.getBoundingClientRect();
        const symbolRect = symbolRef.current!.getBoundingClientRect();
        // const buttonRect = buttonRef.current!.getBoundingClientRect();
        ringX.set(e.clientX - zoneRect!.left - (symbolRect.width / 2));
        ringY.set(e.clientY - zoneRect!.top - (symbolRect.height / 2));

        const centerX = (zoneRect.left + zoneRect.right) / 2;
        const centerY = (zoneRect.top + zoneRect.bottom) / 2;

        const maxDistance = (zoneRect.right - zoneRect.left) / 2;
        // const minDistance = (buttonRect.left - zoneRect.left);
        const distance = Math.sqrt(Math.pow(e.clientX - centerX, 2) + Math.pow(e.clientY - centerY, 2));
        textOpacity.set(distance / maxDistance);
    }

    return (
        <div className='w-full h-96 flex flex-col justify-center items-center gap-y-4 text-white bg-neutral-800'>
            {/* Text */}
            <div className='flex flex-col justify-center items-center gap-y-4 relative'>
                <motion.h2
                    style={{ opacity: textOpacity }}
                    className='text-teko italic text-3xl font-semibold max-w-80 sm:max-w-none'>GET NOTIFIED WHEN OUR LATEST MERCH DROPS</motion.h2>
                <motion.p
                    style={{ opacity: textOpacity }}
                    className='text-xl'>Subscribe and stay stocked!</motion.p>
                <div className='absolute top-0 left-0 size-full flex justify-center items-center'>
                    <AnimatePresence mode='wait'>
                        {wink && <WinkBox key={'wink'} />}
                    </AnimatePresence>
                </div>
            </div>

            <ComingSoonWrap>
                <div className='relative'>
                    <motion.button
                        ref={buttonRef}
                        type='button'
                        className='bg-amber-50 text-teko text-3xl font-semibold px-2 pt-2 pb-1 text-neutral-600 relative z-20'
                        style={{ color: '#525252' }}
                        animate={{ color: '#525252' }}
                        whileHover={{ color: '#000000' }}
                        onPointerEnter={() => animate(textOpacity, 0, { duration: .5, ease: 'easeOut' })}
                        onPointerLeave={() => {
                            setWink(false);
                            animate(textOpacity, 1, { duration: 2, ease: 'easeIn' });
                        }}
                        onClick={() => setWink(true)}
                    >Subscribe
                    </motion.button>

                    {/* Symbol Ring */}
                    <div
                        ref={zoneRef}
                        className='absolute top-0 left-0 size-full p-40 flex -translate-x-32 -translate-y-32'
                        onPointerOverCapture={handleOnPointerEnter}
                        onPointerOutCapture={handleOnPointerLeave}
                        onPointerMove={handleOnPointerMove}
                    >
                        <motion.div
                            ref={symbolRef}
                            layout
                            className='fixed top-0 left-0 pointer-events-none'
                            style={{
                                x: ringX,
                                y: ringY,
                                opacity: ringOpacity
                            }}
                        >
                            <SymbolRing />
                        </motion.div>

                    </div>
                </div>
            </ComingSoonWrap>
        </div>
    )
}

export default EdgeMerchNotice;